import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Fragment, useEffect, useState } from "react";

import { useAxios } from "../../hooks";
import PageHeader from "../../components/PageHeader";
import Form from "./lead campaign components/Form";
import {
  leadCampaignObject,
  objectFromResponse,
} from "./lead campaign components/leadCampaignObject";
import { PrimaryButton, PrimaryLoadingButton } from "../css components/Button";
import { alert } from "../../redux/slices/alertSlice";
import ConfirmPopUp from "./lead campaign components/ConfirmPopUp";
import pages from "../../constants/pages";

export default function Laas() {
  const axios = useAxios();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { configName } = useParams();
  const { subscriptionID } = useParams();

  const [field, setFields] = useState([]);
  const [dialog, setDialog] = useState(false);
  const [loading, setLoading] = useState(false);
  const [editState, setEditState] = useState(true);

  const [formData, setFormData] = useState(leadCampaignObject);

  const { activeBrand } = useSelector((state) => state.memberDetails);

  useEffect(() => {
    if (subscriptionID || configName) {
      let id = subscriptionID ?? configName;
      setEditState(false);
      axios({
        url: "/get/leadCampaign/" + id,
      }).then((response) => {
        if (response.status) {
          setFormData(objectFromResponse(response.data));
        }
      });
    }

    axios({
      url: "/get/leadCampaign/fields",
    }).then((response) => {
      if (response.status) {
        setFields(response.data);
      }
    });
  }, [axios, subscriptionID, configName]);

  return (
    <Fragment>
      <PageHeader
        pageName={
          !configName
            ? formData.subscriptionID
              ? " Lead Qualification Details"
              : "Create Lead Qualification"
            : "API Details"
        }
        pageHeader={
          !configName
            ? formData.subscriptionID
              ? " Lead Qualification Fields Details"
              : "Set parameters to identify and prioritize qualified prospects"
            : " Lead Qualification Field API Details"
        }
        title="Lead Qualification"
        buttons={[
          formData.price && formData.apiDetails && subscriptionID && (
            <PrimaryButton
              onClick={() =>
                navigate(pages.apiLeadCampaignDetails.route + subscriptionID)
              }
              variant="contained"
            >
              API Details
            </PrimaryButton>
          ),
          formData.price && !formData.apiDetails && (
            <PrimaryLoadingButton
              loading={loading}
              onClick={openPopup}
              variant="contained"
            >
              Generate
            </PrimaryLoadingButton>
          ),
        ]}
      />

      <Form
        subscriptionID={subscriptionID}
        configName={configName}
        setFormData={setFormData}
        field={field}
        formData={formData}
        editState={editState}
        setEditState={setEditState}
      />

      <ConfirmPopUp
        loading={loading}
        setDialog={setDialog}
        dialog={dialog}
        handleFreeze={handleFreeze}
        formData={formData}
      />
    </Fragment>
  );

  function openPopup() {
    setDialog(true);
  }

  function handleFreeze() {
    setLoading(true);
    axios({
      url: "/generate/api/detail",
      method: "POST",
      data: {
        brand_id: activeBrand.ID,
        dial_id: subscriptionID,
      },
    }).then((response) => {
      if (response.status) {
        setFormData((prev) => ({
          ...prev,
          apiDetails: "generated",
          status: true,
        }));
        dispatch(
          alert({
            type: "success",
            message: "API details has been generated.",
          })
        );
      }
    });
    setLoading(false);
    setDialog(false);
  }
}
